function isLocal() {
  const hostname = window.location.hostname
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1'
  const isLocalNetwork = hostname.startsWith('192.168.') || hostname.startsWith('10.')
  return isLocalhost || isLocalNetwork
}
const origin = window.location.origin
// const defaultUrl = 'http://en.cxstar.cn'
const defaultUrl = 'https://booken.cxstar.cn'
// const defaultUrl = 'http://192.168.0.146:7080'

const baseUrl = isLocal() ? defaultUrl : origin
const fileUrl = 'https://file.cxstar.cn'

export default { baseUrl, fileUrl }
